<template>
  <main class="mt-3">
    <div class="container">
      <a name="homeTop"></a>
      <h1>결과내 검색기</h1>
      <h3>결과내 검색기능이 작동중일경우 결과수가 달라질수있습니다.</h3>
      <table class="table table-sm table-hover">
        <thead>
          <tr>
           <td colspan="3">검색어 <input type="text" v-model="InputSearch" @keyup.enter="ButtonSearch()"></td>
          </tr>
          <tr>
           <td colspan="3">2번째 검색어 <input type="text" v-model="WithinSearch" @keyup.enter="ButtonSearch()"></td>
          </tr>
          <tr>
            <td colspan="3">
              검색 타입
              <select v-model="SearchType">
                <option value="q=">기본</option>
                <option value="channelId=">채널ID</option>
              </select>
              목록 갯수 <input type="text" v-model="SearchCount" @keyup.enter="ButtonSearch()" style="width: 50px; text-align: right;"> 
              정렬 순서 
              <select v-model="order">
                <option value="date">최신순</option>
                <option value="title">제목순</option>
              </select>
            </td>
          </tr>
          <tr><td><button @click="ButtonSearch" class="btn btn-danger">검색</button></td></tr>
        </thead>
        <!-- 검색된 데이터 출력부 -->
        <tbody>
          <tr :key="i" v-for="(items,i) in youtubeItems">
            <td v-on:click="openUrl(items.videoId)"><img :src="items.imgurl" width="300"></td>
            <td v-on:click="openUrl(items.videoId)">
              <table class="table" style="height:240px">
                <tbody>
                  <!--제목-->
                  <tr style="height:50%"><td>{{items.title}}</td></tr>
                  <!--영상설명-->
                  <tr><td>{{items.description}}</td></tr>
                </tbody>
              </table>
            </td>
            <td>
              <table class="table" style="height:240px">
                <tbody>
                  <!--체널이름-->
                  <tr style="height:50%"><td><a v-on:click="openChannelUrl(items.channelId)">{{items.channelTitle}}</a><br/><hr>{{items.channelId}}</td></tr>
                  <!--공개날짜-->
                  <tr><td>{{items.publishedAt}}</td></tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
      <button class="btn btn-danger" v-if="NextPageToken != ''" @click="MorePage">더불러오기</button>
    </div>
  </main>
</template>

<script>
export default {
    data() {
        return {
            SearchType:"q=",
            InputSearch:"",
            WithinSearch:"",
            SearchCount: 10,
            youtubeItems : [],
            NextPageToken : "",
            order:"date",
            saveSearchType:"",
            saveInputSearch:"",
            saveWithinSearch:"",
            saveSearchCount: 10,
            saveOrder:"date",
        }
    },
    computed :{
    },
    methods : {
        async ButtonSearch() {
          console.log("검색버튼 클릭됨");

          // 검사
          if(this.SearchCount < 1 || this.SearchCount > 50) {
            alert("목록 갯수는 1~50개까지 허용됩니다.")
            this.SearchCount = 10;
            return
          }

          // 검색 개시
          console.log("검색어 : " + this.InputSearch);
          let url = "/API/YTP?action=Within&SearchCount=" + this.SearchCount + "&order=" + this.order + "&SearchType=" + this.SearchType + "&searchText=" + this.InputSearch + "&WithinSearch=" + this.WithinSearch;
          console.log("url sessues : " + url);
          let jsonFile = null;
          try{
            jsonFile = await this.$api(encodeURI(url));
          } catch {
            alert("잘못된 id를 입력 하였습니다.\n기본 검색으로 채널id(채널이름 아래 표시)를 복사한후 검색을 실행해 주세요")
          }
          console.log("youtube search api sussesed : " + jsonFile)
          console.log("youtube search api sussesed : " + jsonFile.searchText)
          console.log("youtube search api sussesed : " + jsonFile.withinSearch)

          // 초기화
          this.NextPageToken = "";

          // 데이터 파싱
          this.youtubeItems = jsonFile.items;
          if(jsonFile.nextPageToken != undefined) {
            this.NextPageToken = jsonFile.nextPageToken;
          }
          console.log("next page token : " + this.NextPageToken)

          function OrderCustonSort(a, b) {
              if(a.publishTime == b.publishTime){ return 0} return  a.publishTime > b.publishTime ? -1 : 1;
          }

          function TitleCustonSort(a, b) {
              if(a.title == b.title){ return 0} return  a.title > b.title ? -1 : 1;
          }

          if(this.order == "date") {
            this.youtubeItems.sort(OrderCustonSort);
          } else if(this.order == "title") {
            this.youtubeItems.sort(TitleCustonSort);
          } else {
            alert("정렬 오류");
          }

          this.saveInputSearch = this.InputSearch;
          this.saveSearchType = this.SearchType;
          this.saveWithinSearch = this.WithinSearch;
          this.saveSearchCount = this.SearchCount;
          this.saveOrder = this.order;
        },

        async MorePage() {
         console.log("더 불러오기 버튼 클릭됨");

          // 변경사항 초기화
          this.InputSearch = this.saveInputSearch;
          this.SearchType = this.saveSearchType;
          this.withinSearch = this.saveWithinSearch;
          this.SearchCount = this.saveSearchCount;
          this.nextPageToken = null;
          this.order = this.saveOrder;

          // 검색 개시
          console.log("검색어 : " + this.InputSearch);
          let url = "/API/YTP?action=WithinMorePage";
          console.log("url sessues : " + url);
          let jsonFile = null;
          try{
            jsonFile = await this.$api(encodeURI(url));
          } catch {
            alert("몬가 잘못되었습니다.")
          }
          console.log("youtube search api sussesed : " + jsonFile)

          // 초기화
          this.NextPageToken = "";

          // 데이터 파싱
          this.youtubeItems = jsonFile.items;
          if(jsonFile.nextPageToken != undefined) {
            this.NextPageToken = jsonFile.nextPageToken;
          }
          console.log("next page token : " + this.NextPageToken)


          function OrderCustonSort(a, b) {
              if(a.publishTime == b.publishTime){ return 0} return  a.publishTime > b.publishTime ? -1 : 1;
          }

          function TitleCustonSort(a, b) {
              if(a.title == b.title){ return 0} return  a.title > b.title ? -1 : 1;
          }

          if(this.order == "date") {
            this.youtubeItems.sort(OrderCustonSort);
          } else if(this.order == "title") {
            this.youtubeItems.sort(TitleCustonSort);
          } else {
            alert("정렬 오류");
          }
        },

        openUrl(id) {
          console.log("유튜브영상으로 이동 : " + id);
          window.open("https://www.youtube.com/watch?v=" + id,'','');
        },

        openChannelUrl(id) {
          console.log("유튜브채널로 이동 : " + id);
          window.open("https://www.youtube.com/channel/" + id,'','');
        }
    },
}
</script>

<style>

</style>